var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcFontDownloadOutline = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ktnzc05wea",
    d: "M8.275 11.25h3.45L10 6.65l-1.725 4.6zm8.392-9.583H3.333c-.916 0-1.666.75-1.666 1.666v13.334c0 .916.75 1.666 1.666 1.666h13.334c.916 0 1.666-.75 1.666-1.666V3.333c0-.916-.75-1.666-1.666-1.666zm-1.334 1.666H4.667c-.734 0-1.334.6-1.334 1.334v10.666c0 .734.6 1.334 1.334 1.334h10.666c.734 0 1.334-.6 1.334-1.334V4.667c0-.734-.6-1.334-1.334-1.334zm-2.041 12.084l-.95-2.5h-4.7l-.934 2.5H4.967L9.225 4.583h1.55l4.258 10.834h-1.741z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "rwz2w16slb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ktnzc05wea"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    xlinkHref: "#ktnzc05wea"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4F5964",
    mask: "url(#rwz2w16slb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H41.667V41.667H0z",
    transform: "translate(-10.833 -10.833)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcFontDownloadOutline, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-font-download-outline.b63226c1.svg";
export { ForwardRef as ReactComponent };